const AuthenticationActionTypes = {
  SET_AUTH: "authentication/SET_AUTH",
  LOG_OUT: "authentication/LOG_OUT",
  ERROR_ON_SIGNING: "authentication/ERROR_ON_SIGNING",
  REMOVE_ERROR: "authentication/REMOVE_ERROR",
};

export default AuthenticationActionTypes;
